import { Component, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslatePipe } from '@ngx-translate/core';
import { IDialogContent } from '../interfaces/dialog-content.interface';

@Component({
  selector: 'lib-alert-dialog',
  imports: [TranslatePipe],
  templateUrl: './alert-dialog.html',
  styleUrl: './alert-dialog.scss',
})
export class AlertDialog {
  public content: IDialogContent = { titleTranslationLabel: '', messageTranslationLabel: '' };

  protected activeModal = inject(NgbActiveModal);
}
